import React from "react";
import { Link } from "react-router-dom";
import {
    FaArrowRight,
    FaBuilding,
    FaLaptopCode,
    FaMobileAlt,
    FaRobot,
    FaHeadset,
    FaExternalLinkAlt,
    FaCube,
} from "react-icons/fa";
import Slider from '../inc/Slider';
import VMC from "./inc/Vmc";
import ZoventVideo from '../images/Zovent.mp4';
import ZoventLogo from '../images/ZoventLogo.png';
import CIITS from '../images/CIITS_page-0004.png';

function Home() {
    // Add the real Zovent live URL below when available.
    const zoventLiveUrl = "https://www.zovent.in/";

    const services = [
        {
            icon: <FaLaptopCode />,
            title: "Web Development",
            copy: "Custom websites to elevate your online presence.",
        },
        {
            icon: <FaMobileAlt />,
            title: "Mobile Apps",
            copy: "User-friendly apps for Android and iOS.",
        },
        {
            icon: <FaRobot />,
            title: "AI Chat Bots",
            copy: "AI-driven bots for enhanced customer engagement.",
        },
        {
            icon: <FaHeadset />,
            title: "AI Voice Assistant",
            copy: "Voice-enabled AI for superior customer support.",
        },
    ];

    const featuredWorks = [
        {
            initials: "Z",
            name: "Zovent",
            type: "Flagship ERP Product",
            status: "Live Now",
            summary:
                "A modern ERP product crafted for pharmacy stores to simplify inventory, billing, analytics, compliance, and customer management in one powerful platform.",
            points: ["Pharmacy ERP", "Inventory & Billing", "Analytics Dashboard"],
            link: zoventLiveUrl,
        },
        {
            initials: "V",
            name: "VCTN Enterprises",
            type: "Full-Stack Client Project",
            status: "Live Project",
            summary:
                "A complete full-stack project developed by CIITS for VCTN Enterprises, including frontend, backend, and production deployment.",
            points: [
                "Frontend Development",
                "Backend Development",
                "End-to-End Delivery"
            ],
            link: "https://www.vctn.in/",
        },
    ];

    return (
        <main>
            <Slider />

            <section className="ciits-section ciits-section--white" aria-labelledby="company-title">
                <div className="ciits-container company-layout">
                    <div className="company-visual">
                        <div className="company-image-card">
                            <img src={CIITS} alt="Our Company" />
                        </div>
                        <div className="company-float-chip">
                            <span><FaBuilding /></span>
                            Central India IT Services
                        </div>
                    </div>

                    <div className="company-copy">
                        <span className="ciits-eyebrow">Who we are</span>
                        <h2 id="company-title" className="ciits-title">
                            Our <span className="gradient-text">Company</span>
                        </h2>
                        <p className="ciits-subtitle">
                            At <strong style={{ color: "#0d1b2a" }}>CIITS</strong>, we deliver innovative IT and software solutions to empower businesses. Our mission is to streamline operations, enhance productivity, and drive growth with customized, reliable services.
                        </p>
                        <Link to="/about" className="ciits-btn ciits-btn--primary">
                            Read More <FaArrowRight size={12} />
                        </Link>
                    </div>
                </div>
            </section>

            <section id="services" className="ciits-section ciits-section--soft" aria-labelledby="services-title">
                <div className="ciits-container">
                    <div className="ciits-section-heading ciits-section-heading--center">
                        <span className="ciits-eyebrow">What we build</span>
                        <h2 id="services-title" className="ciits-title">
                            Our <span className="gradient-text">Services</span>
                        </h2>
                    </div>

                    <div className="services-grid">
                        {services.map((service, index) => (
                            <article className="service-card-modern" key={service.title}>
                                <span className="service-number">0{index + 1}</span>
                                <div className="service-icon-modern" aria-hidden="true">{service.icon}</div>
                                <h3>{service.title}</h3>
                                <p>{service.copy}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <section id="products" className="ciits-section ciits-section--white" aria-labelledby="product-section-title">
                <div className="ciits-container">
                    <div className="ciits-section-heading">
                        <span className="ciits-eyebrow">Built by CIITS</span>
                        <h2 id="product-section-title" className="ciits-title">
                            Our <span className="gradient-text">Product</span>
                        </h2>
                    </div>

                    <div className="product-wrap product-wrap--tilt">
                        <div className="product-media">
                            <div className="product-video-frame">
                                <video controls autoPlay loop muted playsInline>
                                    <source src={ZoventVideo} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>

                        <div className="product-content">
                            <img src={ZoventLogo} alt="Zovent" className="product-logo" />
                            <div className="product-title-row">

                                <span className="product-badge product-badge--live">Launched</span>
                            </div>

                            <p className="product-copy">
                                <strong>Zovent</strong> is a smart inventory, billing, and business management platform designed to simplify day-to-day operations for retail businesses, wholesalers, and SMEs. Manage stock, GST billing, customers, suppliers, accounting, and business reports from one easy-to-use system across Web, Android, Windows, and macOS.
                            </p>

                            <ul className="product-features">
                                <li>📦 Real-time inventory tracking with automatic stock updates</li>
                                <li>🧾 GST-ready billing, invoices, quotations, credit &amp; debit notes</li>
                                <li>👥 Customer &amp; supplier management in one place</li>
                                <li>💰 Track receivables, payables, expenses &amp; accounting records</li>
                                <li>📊 Sales, purchase, inventory &amp; business performance reports</li>
                                <li>🏪 Multi-location stock management</li>
                                <li>📱 Android app with real-time data sync</li>
                                <li>💻 Desktop apps for Windows &amp; macOS</li>
                                <li>🌐 Web access from anywhere</li>
                                <li>☁️ Secure cloud-based business data</li>
                            </ul>

                            <div className="product-actions-row">
                                <a
                                    href={zoventLiveUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="ciits-btn ciits-btn--primary"
                                >
                                    Visit Zovent <FaExternalLinkAlt size={12} />
                                </a>

                                <Link to="/contact" className="ciits-btn ciits-btn--light">
                                    Request Demo <FaArrowRight size={12} />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="featured-work" className="ciits-section ciits-section--soft" aria-labelledby="featured-work-title">
                <div className="ciits-container">
                    <div className="ciits-section-heading ciits-section-heading--center">
                        <span className="ciits-eyebrow">Proof of work</span>
                        <h2 id="featured-work-title" className="ciits-title">
                            Featured <span className="gradient-text">Work</span>
                        </h2>
                        <p className="ciits-subtitle featured-work-subtitle">
                            Showcasing products and business solutions delivered by CIITS for our own ventures and client projects.
                        </p>
                    </div>

                    <div className="project-showcase-grid">
                        {featuredWorks.map((work) => (
                            <article className="project-card-modern" key={work.name}>
                                <div className="project-card-top">
                                    <div className="project-mark" aria-hidden="true">
                                        <FaCube className="project-mark-icon" />
                                        <span>{work.initials}</span>
                                    </div>
                                    <div className="project-headline">
                                        <span className="project-type">{work.type}</span>
                                        <h3>{work.name}</h3>
                                    </div>
                                    <span className="project-status">{work.status}</span>
                                </div>

                                <p className="project-summary">{work.summary}</p>

                                <div className="project-points">
                                    {work.points.map((point) => (
                                        <span key={point}>{point}</span>
                                    ))}
                                </div>

                                <div className="project-card-bottom">
                                    {work.link ? (
                                        <a
                                            href={work.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="project-link"
                                        >
                                            Open Live Project <FaExternalLinkAlt size={11} />
                                        </a>
                                    ) : (
                                        <span className="project-link project-link--muted">Delivered by CIITS</span>
                                    )}
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <VMC />
        </main>
    );
}

export default Home;
